import { render, staticRenderFns } from "./RateSetting.vue?vue&type=template&id=2591685a&scoped=true&"
import script from "./RateSetting.vue?vue&type=script&lang=js&"
export * from "./RateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2591685a",
  null
  
)

export default component.exports